export default "__VITE_ASSET__Cu3ra1$Z__"